import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import ActionTypes from './actionTypes'

type TicketSizeDeleteRequest = {
    type: typeof ActionTypes.TICKET_SIZE_DELETE_REQUEST;
    payload: never;
}

type TicketSizeDeleteFailure = {
    type: typeof ActionTypes.TICKET_SIZE_DELETE_FAILURE;
    payload: Error;
}

type TicketSizeDeleteSuccess = {
    type: typeof ActionTypes.TICKET_SIZE_DELETE_SUCCESS;
    payload: number;
}

function deleteTicketSize(ticketSizeId: number) {
    return createAction<RootState, number, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-sizes/${ticketSizeId}`,
        method: 'DELETE',
        types: [
            ActionTypes.TICKET_SIZE_DELETE_REQUEST,
            {
                type: ActionTypes.TICKET_SIZE_DELETE_SUCCESS,
                payload: ticketSizeId,
            },
            ActionTypes.TICKET_SIZE_DELETE_FAILURE,
        ],
    })
}

export type TicketSizeDeleteAction = TicketSizeDeleteRequest
    | TicketSizeDeleteFailure
    | TicketSizeDeleteSuccess

export default deleteTicketSize
